export default {
  setPersonList (state, personList) {
    state.personList = personList
  },
  setPersonFaceList (state, personFaceList) {
    state.personFaceList = personFaceList
  },
  setCardBasicInfoList (state, cardBasicInfoList) {
    state.cardBasicInfoList = cardBasicInfoList
  },
  setDeviceList (state, data) {
    state.deviceList = data
  },
  setCardTaskRecordList (state, data) {
    state.cardTaskRecordList = data
  },
  setPersonCardList (state, data) {
    state.personCardList = data
  },
  setDeviceVersionRecordList (state, data) {
    state.deviceVersionRecordList = data
  },
  setCardHistoryList (state, data) {
    state.cardHistoryList = data
  },
  setMerchantType (state, data) {
    state.merchantType = data
  },
  setCardCertType (state, data) {
    state.cardCertType = data
  },
  setGenderType (state, data) {
    state.genderType = data
  },
  setCardTaskType (state, data) {
    state.cardTaskType = data
  },
  setMediaType (state, data) {
    state.mediaType = data
  },
  setDepartmentType (state, data) {
    state.departmentType = data
  },
  setDeviceMaintenanceType (state, data) {
    state.deviceMaintenanceType = data
  },
  setPersonStatus (state, data) {
    state.personStatus = data
  },
  setCardStatus (state, data) {
    state.cardStatus = data
  },
  setMakeCardTaskStatus (state, data) {
    state.makeCardTaskStatus = data
  },
  setDeviceStatus (state, data) {
    state.deviceStatus = data
  },
  setReportTranType (state, data) {
    state.reportTranType = data
  },
  clearApplyBaseOptionsAndList (state) {
    state.cardCertType = []
    state.merchantType = []
    state.genderType = []
    state.cardTaskType = []
    state.mediaType = []
    state.departmentType = []
    state.deviceMaintenanceType = []
    state.personStatus = []
    state.cardStatus = []
    state.makeCardTaskStatus = []
    state.deviceStatus = []
    state.personList = []
    state.personFaceList = []
    state.cardBasicInfoList = []
    state.deviceList = []
    state.cardTaskRecordList = []
    state.deviceVersionRecordList = []
    state.personCardList = []
  }
}



// WEBPACK FOOTER //
// ./src/store/apply_basic/mutations.js